module.exports = __webpack_public_path__ + "media/travel-diary.4fa1b156.mp4";